import operatorApiFetch from './apiService';

export const partnerApiLogService = {
  getList: async (params) => {
    const query = new URLSearchParams(params).toString();
    const response = await operatorApiFetch(`partner_api_logs?${query}`);
    return response.json();
  },
  getRecords: async (params) => {
    const response = await operatorApiFetch('partner_api_logs/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },
};
